import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import ServiceOrderFields from './ServiceOrderFields';

export default function ClientRepairFields({ value = {}, onChange }) {
  return <>
    <Row className="g-3 mb-3">
      {[['numar_auto', 'Număr de înmatriculare', 'text'], ['km', 'Kilometraj la recepție', 'number']].map(([key, label, type]) =>
        <Col md={6} key={key}><Form.Group controlId={`client-${key}`}><Form.Label>{label}</Form.Label>
          <Form.Control type={type} min="0" value={value[key] ?? ''} onChange={e => onChange({ ...value, [key]: type === 'number' ? (e.target.value === '' ? null : Number(e.target.value)) : e.target.value })} />
        </Form.Group></Col>)}
    </Row>
    <ServiceOrderFields value={value} onChange={onChange} mouseChoices showInitial={false} />
    <h5>Cost estimat inițial (lei)</h5>
    <Row className="g-3 mb-3">{[['estimat_manopera', 'Manoperă fără TVA'], ['estimat_piese', 'Piese fără TVA'], ['estimat_tva', 'TVA estimată']].map(([key, label]) =>
      <Col md={4} key={key}><Form.Group controlId={`client-${key}`}><Form.Label>{label}</Form.Label>
        <Form.Control type="number" min="0" step="0.01" value={value[key] ?? ''} onChange={e => onChange({ ...value, [key]: e.target.value === '' ? null : e.target.value })} />
      </Form.Group></Col>)}</Row>
    <p className="text-muted small">Sumele necompletate rămân goale pe document. Lucrările suplimentare necesită acord scris separat.</p>
  </>;
}
